export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-shape/src/identity.js
// module id = ../../../../d3-shape/src/identity.js
// module chunks = 3